<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>

export default {
    name: "App",
    data() {
        return {

        }
    },
    mounted() {
        // 获取个人信息
        this.getUserInfo()

        // 获取访问来源
        this.getAccessSource()

        // 获取超商地址
        this.common.getSupermarketArea()
    },
    methods: {
        // 获取个人信息
        getUserInfo: function () {
            this.common.requestDataParams('/api/users', 'GET', {}).then((response) => {
                if (response.data == '') {
                    // 未登录或者登录失效
                    localStorage.removeItem('userToken')
                    localStorage.removeItem('userInfo')
                } else {
                    var res = response.data.body
                    localStorage.setItem('userInfo', JSON.stringify(res)) // 更新userInfo
                }
            }).catch((error) => {
                console.log(error)
            })
        },

        // 获取访问来源
        getAccessSource: function () {
            var affiliate = this.common.getUrlKey('affiliate') // 投放人
            var adlk = this.common.getUrlKey('adlk') // 广告id
            if (affiliate) {
                sessionStorage.setItem('affiliate', affiliate)
            } else {
                // 没有投放人判断是否在app中
                if (this.common.isApp()) {
                    sessionStorage.setItem('affiliate', this.common.isIosOrAndroid())
                }
            }
            if (adlk) {
                sessionStorage.setItem('adlk', adlk)
            }
        }
    }
}
</script>

<style>
@import '../src/assets/css/style.css';

#app {
    height: 100%;
    max-width: 720px;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue